import { Component, type ErrorInfo, type ReactNode } from 'react';
import { recordCrashLog } from '@app/lib/crashDiagnostics';

export class ErrorBoundary extends Component<{ children: ReactNode }, { hasError: boolean }> {
  state = { hasError: false };

  static getDerivedStateFromError(): { hasError: boolean } {
    return { hasError: true };
  }

  componentDidCatch(error: unknown, errorInfo: ErrorInfo): void {
    console.error('[service-companion:error-boundary]', error, errorInfo);
    recordCrashLog({
      type: 'react',
      error,
      ...(errorInfo.componentStack ? { componentStack: errorInfo.componentStack } : {})
    });
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <div className="fatal-shell">
          <div className="fatal-card">
            <p className="eyebrow">Recovery</p>
            <h1>Something went wrong.</h1>
            <p>Tap reload to recover the workspace.</p>
            <button type="button" className="btn btn-primary" onClick={() => window.location.reload()}>
              Reload app
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
